import { StaffMissingInformationItem } from '../../../../lib/types/models/staff/staff'

export const getStaffProfileMissingInformationItems = (
  staff: unknown,
  onClick: () => void
): StaffMissingInformationItem[] => {
  if (!staff || typeof staff !== 'object') return []

  const profileInformation = staff as {
    ibanDetailsFilled?: boolean
    emergencyContactDetailsFilled?: boolean
  }

  const missingInformation: StaffMissingInformationItem[] = []

  if (profileInformation.ibanDetailsFilled === false) {
    missingInformation.push({
      label: 'staff.personal.space.missing.iban',
      onClick
    })
  }

  if (profileInformation.emergencyContactDetailsFilled === false) {
    missingInformation.push({
      label: 'staff.personal.space.missing.emergency.contact.details',
      onClick
    })
  }

  return missingInformation
}
